import { configureStore, ConfigureStoreOptions } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import {
	authSlice,
	landingSlice,
	invitationsSlice,
	notificationsSlice,
	mapsSlice,
	ordersSlice,
	transactionsSlice,
	affiliateSlice
} from "./slices";
import { api, fileApi } from "./services";
import { fileAPI } from "./services/file/file.service";

// const rootReducer = combineReducers({
// 	[landingApi.reducerPath]: landingSlice
// });

// const store = configureStore({
// 	reducer: rootReducer,
// 	middleware: getDefaultMiddleware => getDefaultMiddleware().concat(landingApi.middleware as ThunkMiddleware)
// });

export const createStore = (options?: ConfigureStoreOptions["preloadedState"] | undefined) =>
	configureStore({
		reducer: {
			auth: authSlice,
			landing: landingSlice,
			invitations: invitationsSlice,
			notifications: notificationsSlice,
			maps: mapsSlice,
			orders: ordersSlice,
			transactions: transactionsSlice,
			affiliate: affiliateSlice,
			[api.reducerPath]: api.reducer,
			[fileApi.reducerPath]: fileApi.reducer
		},
		middleware: getDefaultMiddleware => getDefaultMiddleware().concat(api.middleware).concat(fileAPI.middleware),
		...options
	});

export const store = createStore();
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
